"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var CONTACT_INFO_SYSTEM_FIELDS = {
    firstName: {},
    lastName: {},
    picture: { schemaKey: 'imageUrl' },
    emails: {},
    phones: {},
    labels: {},
};
var constatns = {
    CONTACT_INFO_SYSTEM_FIELDS: CONTACT_INFO_SYSTEM_FIELDS,
};
var serializeContactInfo = function (rawContactInfo) {
    return lodash_1.reduce(rawContactInfo, function (result, value, key) {
        var systemField = CONTACT_INFO_SYSTEM_FIELDS[key];
        if (systemField) {
            result[systemField.serviceKey || key] = value;
            return result;
        }
        var customFieldType = 'strValue';
        if (lodash_1.isDate(value)) {
            customFieldType = 'dateValue';
        }
        else if (lodash_1.isNumber(value)) {
            customFieldType = 'numValue';
        }
        result.customFields.push((_a = {
                name: key
            },
            _a[customFieldType] = value,
            _a));
        return result;
        var _a;
    }, { customFields: [] });
};
exports.serializeContactInfo = serializeContactInfo;
//# sourceMappingURL=contacts.js.map